// src/com/sms_message/SmsMessageDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// SMS 전송 기록, sms_message
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    smsMessageSeq : {
		id: 'smsMessageSeq', label: 'smsMessageSeq',
		type: InputType.number, required: true, toAdd: false, toEdit: true,
	}, // int(11)
    message : {
		id: 'message', label: '전송내용',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 1, 700)},
	}, // varchar(700)
    receiveTelList : {
		id: 'receiveTelList', label: '수신전화번호',
		type: InputType.list, required: true, toAdd: true, toEdit: true,
		check: (value) => {return Boolean(value) && value.length > 0},
	}, // varchar(14)
    
};

/**
 * SMS_MESSAGE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-01-24 11:22:03 using DbdbTap
 * https://www.dbdbtap.com
 */
export const SmsMessageDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '문자 전송 오류',
        Get: '문자 전송기록 조회 오류',
    },
    tableProps: {
        tableId: 'smsMessageTable',
        uniqueKey: 'smsMessageSeq',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'regDate', label: "전송", width: 160, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            { id: 'recvTel', label: '수신번호', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'userName', label: '송신자', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'callTel', label: '회신번호', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'message', label: Dict.message.label, width: 400, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: '업체', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    receiverTableProps: {
        tableId: 'receiverTable',
        uniqueKey: 'phone',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: true,
            hideColumnConfig: true,
            hideBubble: true,
            growToFill: true,
        },
        columns: [
            { id: 'phone', label: "전화번호", width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'name', label: '이름', width: 150, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    }
};
